import { render } from "./Scrollpane.vue?vue&type=template&id=56d2925c&scoped=true"
import script from "./Scrollpane.vue?vue&type=script&lang=js"
export * from "./Scrollpane.vue?vue&type=script&lang=js"

import "./Scrollpane.vue?vue&type=style&index=0&id=56d2925c&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/得乐线上化/dele-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d2925c"]])

export default __exports__